var map = {
	"./360-icon.png": 1393,
	"./dummy-render-image-2.png": 8336,
	"./dummy-render-image.png": 4467,
	"./foyr-logo-with-name.png": 7215,
	"./header-logo.png": 4235,
	"./logo.png": 6949,
	"./outline-1.png": 9262,
	"./outline-2.png": 8721,
	"./outline-3.png": 5946,
	"./outline-4.png": 7704,
	"./outline-5.png": 8590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8755;